import React from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Divider, TextField, Typography} from '@mui/material';
import MdRenderer from "crqlar-react-common/dist/components/MdRenderer";
import MdEditor from "crqlar-react-common/dist/components/MdEditor";
import {WelcomeScreen} from "crqlar-react-common/dist/models/forms/form";

interface WelcomeInputProps {
    question: WelcomeScreen;
    onQuestionUpdate: (question: WelcomeScreen) => void;
    isSelected?: boolean;
    onSelect?: () => void;
}

const WelcomeInput: React.FC<WelcomeInputProps> = ({
                                                       question,
                                                       onQuestionUpdate,
                                                       isSelected = false,
                                                       onSelect
                                                   }) => {
    const {t} = useTranslation();

    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onQuestionUpdate({
            ...question,
            title: e.target.value
        });
    };

    const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onQuestionUpdate({
            ...question,
            description: e.target.value
        });
    };

    return (
        <Box
            onClick={onSelect}
            sx={{
                p: 4,
                borderRadius: 1,
                border: isSelected ? '2px solid' : '1px solid',
                borderColor: isSelected ? 'primary.main' : 'divider',
                backgroundColor: isSelected ? 'action.selected' : 'background.paper',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                    borderColor: 'primary.light',
                    backgroundColor: 'action.hover'
                }
            }}
        >
            {/* Welcome Section Header */}
            <Typography variant="overline" color="primary" sx={{mb: 2, display: 'block', fontWeight: 'bold'}}>
                {t('Welcome Section')}
            </Typography>

            {isSelected ? (
                <>
                    <TextField
                        fullWidth
                        label={t('Welcome Title')}
                        value={question.title}
                        onChange={handleTitleChange}
                        variant="standard"
                        sx={{mb: 2}}
                        onClick={(e) => e.stopPropagation()}
                    />

                    <MdEditor
                        value={question.description || ''}
                        onChange={(value) => onQuestionUpdate({
                            ...question,
                            description: value
                        })}
                        placeholder={t('Welcome Description')}
                        className={'mini-mdx'}
                    />

                    {/*<TextField*/}
                    {/*  fullWidth*/}
                    {/*  label="Welcome Description"*/}
                    {/*  value={question.description || ''}*/}
                    {/*  onChange={handleDescriptionChange}*/}
                    {/*  variant="standard"*/}
                    {/*  multiline*/}
                    {/*  rows={2}*/}
                    {/*  onClick={(e) => e.stopPropagation()}*/}
                    {/*/>*/}
                </>
            ) : (
                <>
                    <Typography variant="h5" gutterBottom fontWeight="bold">
                        {question.title}
                    </Typography>
          {question.description && (
              <MdRenderer>
                  {question.description}
              </MdRenderer>
          )}
                </>
            )}

            <Divider sx={{mt: 3}}/>
        </Box>
    );
};

export default WelcomeInput;
